<template>
    <v-card>
        <v-card-title>
            <span class="headline">Historial cupón</span>
            <v-spacer/>
            <v-btn
                small
                @click="order_inverse = !order_inverse"
            >
                {{ order_inverse ? 'Descendente' : 'Ascendente' }}
            </v-btn>
            <v-btn
                color="gray"
                icon
                text
                @click="$emit('form:close')"
            >
                <v-icon color="black">
                    close
                </v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-timeline align-top>
                <v-slide-x-reverse-transition
                    group
                    hide-on-leave
                >
                    <v-timeline-item
                        v-for="item in orderItems"
                        :key="item.created_at"
                        :color="colorStatus(item.type)"
                        :icon="iconStatus(item.type)"
                        small
                        fill-dot
                    >
                        <v-card
                            :color="colorStatus(item.type)"
                            dark
                        >
                            <v-card-title class="title">
                                {{ formatFecha(item.created_at) }}
                            </v-card-title>
                            <v-card-text class="white text--primary">
                                <table>
                                    <tr>
                                        <td>
                                            <v-icon color="black">
                                                email
                                            </v-icon>
                                        </td>
                                        <td>{{ item.email }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-icon color="black">
                                                account_circle
                                            </v-icon>
                                        </td>
                                        <td>{{ item.nombre }}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <v-icon color="black">
                                                note
                                            </v-icon>
                                        </td>
                                        <td>{{ textCantidad(item.cantidad, item.type) }}</td>
                                    </tr>
                                    <tr v-if="item.comentarios">
                                        <td colspan="2">
                                            <p>
                                                {{ item.comentarios }}
                                            </p>
                                        </td>
                                    </tr>
                                </table>
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-slide-x-reverse-transition>
            </v-timeline>
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="gray darken-1"
                @click="$emit('form:close')"
            >
                Cerrar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import moment from 'moment';

    moment.locale('es');
    export default {
        name: "TimelineCupon",
        props: {
            timeline: {
                type: [Array, Object]
            },
        },
        data() {
            return {
                order_inverse: false
            }
        },
        computed: {
            orderItems() {
                let items = this.$_clonar(this.timeline);
                if (this.order_inverse) {
                    return items.reverse();
                }

                return items;
            }
        },
        methods: {
            formatFecha(fecha) {
                let fecha_moment = moment.unix(fecha);
                return fecha_moment.format('D [de] MMMM YYYY, h:mm:ss a');
            },
            colorStatus(status) {
                switch (status) {
                    case 'add' :
                        return 'success';
                    case 'exchange':
                        return 'info';
                    default :
                        return 'grey';
                }
            },
            iconStatus(status) {
                switch (status) {
                    case 'add' :
                        return 'add';
                    case 'exchange':
                        return 'transform';
                    case 'cancel':
                        return 'error';
                    default :
                        return 'notification_important';
                }
            },
            textCantidad(cantidad, status) {
                let text = cantidad.toString() + ' ' + (parseInt(cantidad) > 1 ? 'Cupones ' : 'Cupón ');
                switch (status) {
                    case 'add' :
                        text += parseInt(cantidad) > 1 ? ' agregados' : ' agregado';
                        break;
                    case 'exchange':
                        text += parseInt(cantidad) > 1 ? ' cambiados' : ' cambiado';
                        break;
                    case 'cancel':
                        text += parseInt(cantidad) > 1 ? ' cancelados' : ' cancelado';
                        break;
                    default :
                        return 'notification_important';
                }

                return text;
            }
        }
    }
</script>

<style scoped>

</style>
